import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy,
  Input,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Response } from 'src/services/classes/models/response';
import { NotificationsService } from 'src/services/classes/notifications/notifications.service';
import { Logger } from 'src/services/core/logger/logger.service';
import { untilDestroyed } from 'src/services/core/until-destroyed/until-destroyed';
import { RestaurantService } from 'src/services/data/restaurant/restaurant.service';
import { OrdersService } from 'src/services/data/orders/orders.service';
import { Restaurant } from 'src/services/classes/models/restaurant';

const log = new Logger('TableForm');

export interface RestaurantTable {
  id: number;
  name: string;
  status?: string;
}
@Component({
  selector: 'app-table-form',
  templateUrl: './table-form.component.html',
  styleUrls: ['./table-form.component.scss'],
})
export class TableFormComponent implements OnInit, OnDestroy {
  tableForm: FormGroup;
  @Output() tableNumberEmitter = new EventEmitter<string>();
  @Input() buttonText: string;
  allTables: RestaurantTable[] = [];
  restaurantInfo: Restaurant = null;

  constructor(
    private fb: FormBuilder,
    private restaurantService: RestaurantService,
    private notifyService: NotificationsService,
    private ordersService: OrdersService
  ) {}

  ngOnInit(): void {
    this.tableForm = this.fb.group({
      tableNumber: ['', Validators.required],
    });

    this.restaurantInfo = this.restaurantService.fetchRestaurantInformation();
    this.getAllTables(this.restaurantInfo.branchId);
  }

  getAllTables(restaurantId: number) {
    const tables$ =
      this.restaurantService.getOpenTablesInRestaurant(restaurantId);
    tables$.pipe(untilDestroyed(this)).subscribe(
      (res: Response) => {
        if (res.status.toLowerCase() !== 'error') {
          if (res.data && Array.isArray(res.data) && res.data.length > 0) {
            log.debug('res: ', res);
            this.allTables = res.data.filter(
              (item: RestaurantTable) =>
                item.status && item.status.toLowerCase() === 'open'
            );
          }
        } else {
          this.notifyService.publishMessages(res.message, 'danger', 1);
        }
      },
      (error) => log.debug('error: ', error)
    );
  }

  getOpenTableOrders(payload: any) {
    const openTables$ = this.ordersService.getDishesForSelectedTable(payload);
    openTables$.pipe(untilDestroyed(this)).subscribe(
      (res: Response) => {
        if (res.status.toLowerCase() !== 'error') {
          log.debug('open orders: ', res.data);
          if (
            res.data &&
            res.data.orders &&
            Array.isArray(res.data.orders) &&
            res.data.orders.length > 0
          ) {
            const orderCreationTime = res.data?.sessionStarted || null;
            if (orderCreationTime !== null) {
              if (this.lessThanThreeHoursAgo(orderCreationTime)) {
                const previousOrdersData =
                  JSON.parse(localStorage.getItem('allOrders')) || [];
                localStorage.setItem(
                  'allOrders',
                  JSON.stringify([...previousOrdersData, ...res.data.orders])
                );

                log.debug('orders: ', res.data, previousOrdersData);
              }
            }
          }
        } else {
          this.notifyService.publishMessages(res.message, 'danger', 1);
        }
      },
      (error) => log.debug('error: ', error)
    );
  }

  submitTableNumber() {
    const { tableNumber } = this.tableForm.value;

    const tableObject =
      this.allTables.find(
        (table: RestaurantTable) => table.id === tableNumber
      ) || null;
    if (tableObject !== null) {
      localStorage.setItem('table-name', tableObject?.name);
    }

    this.getOpenTableOrders({
      restaurantBranchId: this.restaurantInfo.branchId,
      tableId: tableNumber,
    });
    this.tableNumberEmitter.emit(tableNumber);
    this.tableForm.reset();
  }

  lessThanThreeHoursAgo = (sessionDate: string) => {
    const threeHours = 3 * (1000 * 60 * 60);
    // @ts-ignore
    return new Date() - new Date(sessionDate) < threeHours;
  };

  ngOnDestroy() {}
}
